export const formItemLayout = {
  labelCol: {
    xs: { span: 7 },
    sm: { span: 7 },
  },
  wrapperCol: {
    xs: { span: 16 },
    sm: { span: 16 },
  },
};

export const NumberRuleKeys = {
  PREFIX: 'prefix',
  SUFFIX: 'suffix',
  INCLUDE: 'include',
  NON_PREFIX: 'nonPrefix',
  NON_SUFFIX: 'nonSuffix',
  NON_INCLUDE: 'nonInclude',
};
// start with/end with/not start with/not end with/contain /not contain
export const NumberRuleGroup = [
  {
    label: 'SELECT_NUMBER_MODAL_START',
    value: NumberRuleKeys.PREFIX,
  },
  {
    label: 'SELECT_NUMBER_MODAL_END',
    value: NumberRuleKeys.SUFFIX,
  },
  {
    label: 'SELECT_NUMBER_MODAL_NO_START',
    value: NumberRuleKeys.NON_PREFIX,
  },
  {
    label: 'SELECT_NUMBER_MODAL_NO_END',
    value: NumberRuleKeys.NON_SUFFIX,
  },
  {
    label: 'SELECT_NUMBER_MODAL_CONTAIN',
    value: NumberRuleKeys.INCLUDE,
  },
  {
    label: 'SELECT_NUMBER_MODAL_NO_CONTAIN',
    value: NumberRuleKeys.NON_INCLUDE,
  },
];

export const NumberState = {
  INACTIVE: 'I', // 未启用
  AVAILABLE: 'A', // 可选
  LOCKED: 'L', // 锁定
  ACTIVE: 'C', // 占用
  TERMINATED: 'T', // 销号
  RESERVED: 'R', // 预留
  PORT_OUT: 'P', // 本网号码
  DISCARD: 'D', // 丢弃
  BATCH_LOCK: 'B', // 批开锁定状态
};

export const NumberStateOpt = () => {
  const result = {};
  Object.keys(NumberState).forEach(key => {
    const baseInfo = {
      disabled: NumberState[key] !== NumberState.AVAILABLE, // 是否可选，true -> 不可选， false -> 可选
    };
    result[NumberState[key]] = baseInfo;
  });
  return result;
};

export const NbrOperType = {
  LOCKED: 'LK', // 号码锁定
  UN_LOCKED: 'UL', // 号码解锁
};
